import { useState, useEffect } from 'react';
import axios from 'axios';
import { Input } from './ui/input';
import { Label } from './ui/label';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const BitcoinCalculator = () => {
  const [btc, setBtc] = useState('');
  const [usd, setUsd] = useState('');
  const [brl, setBrl] = useState('');
  const [prices, setPrices] = useState(null);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const response = await axios.get(`${API}/bitcoin/price`);
        setPrices(response.data.bitcoin);
      } catch (error) {
        console.error('Error fetching price:', error);
      }
    };
    fetchPrice();
  }, []);

  const handleBtcChange = (value) => {
    setBtc(value);
    if (prices && value) {
      const btcNum = parseFloat(value);
      setUsd((btcNum * prices.usd).toFixed(2));
      setBrl((btcNum * prices.brl).toFixed(2));
    } else {
      setUsd('');
      setBrl('');
    }
  };

  const handleUsdChange = (value) => {
    setUsd(value);
    if (prices && value) {
      const usdNum = parseFloat(value);
      setBtc((usdNum / prices.usd).toFixed(8));
      setBrl((usdNum * (prices.brl / prices.usd)).toFixed(2));
    } else {
      setBtc('');
      setBrl('');
    }
  };

  const handleBrlChange = (value) => {
    setBrl(value);
    if (prices && value) {
      const brlNum = parseFloat(value);
      setBtc((brlNum / prices.brl).toFixed(8));
      setUsd((brlNum * (prices.usd / prices.brl)).toFixed(2));
    } else {
      setBtc('');
      setUsd('');
    }
  };

  return (
    <div className="bg-card border border-border rounded-sm p-6" data-testid="bitcoin-calculator">
      <h3 className="text-2xl font-bold mb-6">Calculadora Bitcoin</h3>
      <div className="space-y-4">
        <div>
          <Label htmlFor="btc">Bitcoin (BTC)</Label>
          <Input
            id="btc"
            type="number"
            placeholder="0.00000000"
            value={btc}
            onChange={(e) => handleBtcChange(e.target.value)}
            className="font-mono text-lg"
            data-testid="btc-input"
          />
        </div>
        <div>
          <Label htmlFor="usd">Dólar (USD)</Label>
          <Input
            id="usd"
            type="number"
            placeholder="0.00"
            value={usd}
            onChange={(e) => handleUsdChange(e.target.value)}
            className="font-mono text-lg"
            data-testid="usd-input"
          />
        </div>
        <div>
          <Label htmlFor="brl">Real (BRL)</Label>
          <Input
            id="brl"
            type="number"
            placeholder="0.00"
            value={brl}
            onChange={(e) => handleBrlChange(e.target.value)}
            className="font-mono text-lg"
            data-testid="brl-input"
          />
        </div>
      </div>
    </div>
  );
};